import type { CreationInfo } from '@/app/types';

const firstNonEmptyUri = (...uris: Array<string | undefined>) => {
  return uris.find((uri) => uri && uri.trim().length > 0) ?? '';
};

export const getOfflineAvatarCreationPreview = (
  creation?: CreationInfo | null,
): {
  url: string;
  type: 'image' | 'video';
} => {
  if (!creation) return { url: '', type: 'image' };

  if (creation.type === 'video' || creation.type === 'mini_video') {
    const videoUrl = firstNonEmptyUri(creation.nomark_uri, creation.uri, creation.download_uri);
    if (videoUrl) {
      return { url: videoUrl, type: 'video' };
    }

    return { url: firstNonEmptyUri(creation.cover_uri), type: 'image' };
  }

  return {
    url: firstNonEmptyUri(creation.cover_uri, creation.nomark_uri, creation.uri, creation.download_uri),
    type: 'image',
  };
};
